import { useMemo } from 'react';
import { AccountTypeTextes, CardTypesEnum, ServiceConfig } from '@common-fe/common-fe';

import { PHARMACY_TYPE, replaceRxWithPharmacyType } from '@/modules/HealthPlan/HealthPlanSetup/ComplexConfiguration/EnrollmentMatrix/AddServicePaymentModal/queries/useServiceType.query.ts';

export const useHasUnselectedServiceTypes = (
  serviceConfigs: ServiceConfig[],
  healthPlanTypes?: string[]
) => {
  const updatedPlanTypes = useMemo(
    () => replaceRxWithPharmacyType(healthPlanTypes),
    [healthPlanTypes]
  );

  const unselectedServiceTypes = useMemo(() => {
    const types = serviceConfigs
      ?.filter(item => !updatedPlanTypes?.includes(item.serviceType || ''))
      .map(item => {
        const normalizedServiceType =
          item?.serviceType === PHARMACY_TYPE ? CardTypesEnum.RX : item?.serviceType;
        return AccountTypeTextes[normalizedServiceType as keyof typeof AccountTypeTextes] || '';
      });
    return Array.from(new Set(types));
  }, [serviceConfigs, updatedPlanTypes]);

  const hasUnselectedServiceTypes = useMemo(
    () => unselectedServiceTypes?.length > 0,
    [unselectedServiceTypes.length]
  );

  return { hasUnselectedServiceTypes, unselectedServiceTypes };
};
